import {
  Table,
  Button,
  Switch,
  Popconfirm,
  Tooltip,
  Avatar,
  Input,
  notification,
  Spin,
  Tag,
} from "antd";
import * as React from "react";
import { get } from "lodash";
import { getAllUser } from "../../Graphs/User/listUser";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import {
  UserOutlined,
  EditOutlined,
  DeleteOutlined,
  LockOutlined,
  SecurityScanOutlined,
} from "@ant-design/icons";
import { deleteAdmin } from "../../Graphs/Admin/deleteAdmin";
import { changeStatus } from "../../Graphs/Admin/changeStatus";
import { editAdmin } from "../../Graphs/Admin/editAdmin";
import { getAllAdmin } from "../../Graphs/Admin/listAdmin";
import { searchAdmin } from "../../Graphs/Admin/searchAdmin";
import { searchUser } from "../../Graphs/User/searchUser";
import { changePassword } from "../../Graphs/Admin/changePassword";
import { EditModal } from "./EditModal";
import { ChangePassowordModal } from "./ChangePassowordModal";
import { UpdateRoleModal } from "./UpdateRoleModal";
import { checkPermission } from "../AdminUser/CheckPremission";

var moment = require("moment");

const userRole = { subAdmin: "Sub Admin", superAdmin: "Super Admin", corporate: "Corporate" };

const BASE_IMAGE_URL =
  "https://s3.us-east-2.amazonaws.com/cerebrus-consulting/bloodman_user_media/";

const NativeSelect = ({ value, onChange, children, className }) => {
  return (
    <select
      value={value}
      onChange={(e) => onChange(Number(e.target.value))}
      className={className}
      style={{
        padding: "3px 20px 3px 8px",
        borderRadius: "4px",
        border: "1px solid #d9d9d9",
        backgroundColor: "#fff",
        outline: "none",
        cursor: "pointer",
        marginLeft: "8px",
        height: "28px",
        fontSize: "12px",
      }}
    >
      {React.Children.map(children, (child) => {
        if (!child) return null;
        return <option value={child.props.value}>{child.props.children}</option>;
      })}
    </select>
  );
};

class AdminRecordsTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      isLoading: true,
      startIndex: 0,
      limitNumber: 10,
      pagination: {
        pageSize: 10,
        current: 1,
      },
    };
    //this.handleTableChange = this.handleTableChange.bind(this);
    //this.getLimitedUser = this.getLimitedUser.bind(this);
  }

  async componentDidMount() {
    const { loginUserData } = this.props;
    const canEdit = checkPermission(loginUserData, "admin", "edit");
    const canDelete = checkPermission(loginUserData, "admin", "delete");
    const canView = checkPermission(loginUserData, "admin", "view");

    if (!canEdit && !canDelete && !canView) {
      this.columns = this.columns.filter((item) => item.key !== "action");
    }

    this.setState({
      data: this.props.data,
      isLoading: false,
      adminSelectedData: null,
    });
  }

  modalRef;
  changePasswordmodalRef;
  changeUpdateRoleModalRef;

  listAdminData = async () => {
    const {
      authToken,
      history,
      setLoginFlag,
      setUserData,
      setUserToken,
      setListAdminData,
      setListAdminDataTotal,
    } = this.props;

    try {
      let adminData = await getAllAdmin(authToken, 0, 10);

      if (adminData.status === 200) {
        //set user data
        console.log("admin data", adminData);
        // await setListAdminData(adminData.data.docs);
        await setListAdminData(adminData.data);
        await setListAdminDataTotal(adminData.total);
        // console.log(adminData.data.docs);
        // this.setState({
        //   userList: adminData.data.docs,
        //   userTotal: adminData.total,
        // });
      } else if (adminData.status === 401) {
        await setLoginFlag(false);
        await setUserData(null);
        await setUserToken(null);
        history.push(`${process.env.PUBLIC_URL}/login`);
      }
    } catch (e) {
      throw e;
    } finally {
      this.setState({
        isLoading: false,
      });
    }
  };

  async getLimitedAdmin(pagination) {
    const { searchText } = this.props;
    console.log("tempCounter && counter --> ", this.tempCounter, this.counter);
    const start =
      pagination.current * pagination.pageSize - pagination.pageSize;
    const end = pagination.pageSize;

    this.setState(
      {
        isLoading: true,
        startIndex: start,
        limitNumber: end,
      },
      async () => {
        if (searchText != null && searchText !== "") {
          //get search text props from redux store
          this.listSearchAdminData(start, end);
        } else {
          //call normal user Data
          this.listAdminData(start, end);
        }
      }
    );
  }

  listSearchAdminData = async (start, end) => {
    try {
      const {
        authToken,
        history,
        setLoginFlag,
        setUserData,
        setUserToken,
        setListAdminData,
        setListAdminDataTotal,
        searchText,
      } = this.props;
      this.setState({
        isLoading: true,
      });

      let userData = await searchAdmin(
        authToken,
        searchText,
        start,
        end,
        "Teacher"
      );

      if (userData.status === 200) {
        //set user Data
        // await setListAdminData(userData.data.docs);
        await setListAdminData(userData.data);
        await setListAdminDataTotal(userData.total);

        this.setState({
          isLoading: false,
          data: userData.data,
          // data: userData.data.docs,
        });
      } else if (userData.status == 401) {
        await setLoginFlag(false);
        await setUserData(null);
        await setUserToken(null);
        history.push(`${process.env.PUBLIC_URL}/login`);
      }
    } catch (e) {
      console.log("!!!!!!!list search user Data printed here", e);
    } finally {
      this.setState({
        isLoading: false,
      });
    }
  };

  showModal(item) {
    console.log("open modal", item);
    this.setState(
      {
        adminSelectedData: item,
        // isOpen: true
      },
      () => {
        this.modalRef.show();
      }
    );
  }

  showChangePasswordModal(item) {
    console.log("open modal", item);
    this.setState(
      {
        adminSelectedData: item,
        // isOpen: true
      },
      () => {
        this.changePasswordmodalRef.show();
      }
    );
  }

  showUpdateRoleModal(item) {
    console.log("open modal", item);
    this.setState(
      {
        adminSelectedData: item,
        // isOpen: true
      },
      () => {
        this.changeUpdateRoleModalRef.show();
      }
    );
  }

  handleModalclose() {
    this.setState({
      adminSelectedData: null,
    });
  }

  counter = 0;
  tempCounter = 0;
  columns = [
    {
      title: "Sr. No.",
      key: "serial_number",
      width: 70,
      render: (text, item, index) => {
        return (
          <div>
            <span>{++index + this.tempCounter}</span>
          </div>
        );
      },
    },
    {
      title: "Name",
      width: 150,
      key: "name",
      render: (text, item, index) => {
        console.log("user record --> ", item);
        return (
          <div>
            <strong>
              <Tooltip placement="bottom" title="Name">
                <div>{item.first_name ? item.first_name : " "}</div>
              </Tooltip>
            </strong>
          </div>
        );
      },
    },
    {
      title: "Email",
      width: 100,
      key: "email",
      render: (text, item, index) => {
        return (
          <div>
            <strong>
              <Tooltip placement="bottom" title="Email">
                <div>{item.email ? item.email : "-"}</div>
              </Tooltip>
            </strong>
          </div>
        );
      },
    },
    {
      title: "Role",
      width: 100,
      key: "role",
      render: (text, item, index) => {
        return (
          <div>
            <strong>
              <Tooltip placement="bottom" title="Role">
                <div>
                  {item.role ? (
                    <Tag color="geekblue" key={item.role}>
                      {userRole[item.role]}
                    </Tag>
                  ) : (
                    "-"
                  )}
                </div>
              </Tooltip>
            </strong>
          </div>
        );
      },
    },
    {
      title: "Active",
      width: 100,
      key: "is_active",
      render: (text, item, index) => {
        const { loginUserData } = this.props;
        const canEdit = checkPermission(loginUserData, "admin", "edit");
        return (
          <div>
            {item.is_active != null ? (
              <Tooltip placement="bottom" title="Admin Activation">
                {
                  <Switch
                    checked={item.is_active}
                    style={{
                      backgroundColor: item.is_active
                        ? this.props.primaryColor
                        : "#bababa",
                    }}
                    onChange={this.onChange.bind(this, item)}
                    disabled={!canEdit}
                  />
                }
              </Tooltip>
            ) : (
              "-"
            )}
          </div>
        );
      },
    },
    {
      title: "Actions",
      width: 130,
      key: "action",
      render: (text, item, index) => {
        const { loginUserData } = this.props;
        const canEdit = checkPermission(loginUserData, "admin", "edit");
        const canDelete = checkPermission(loginUserData, "admin", "delete");

        return (
          <div style={{ display: "inline-block", width: "100%" }}>
            {canEdit && (
              <div mr="5px" style={{ float: "left" }}>
                <Tooltip placement="bottom" title="Edit">
                  <Button
                    shape="circle"
                    icon={<EditOutlined />}
                    onClick={() => {
                      this.showModal(item);
                    }}
                  />
                </Tooltip>
              </div>
            )}
            {canEdit && (
              <div
                ml="15px"
                mr="5px"
                style={{ float: "left", marginLeft: "10px" }}
              >
                <Tooltip placement="bottom" title="Change Password">
                  <Button
                    shape="circle"
                    icon={<LockOutlined />}
                    onClick={() => {
                      this.showChangePasswordModal(item);
                    }}
                  />
                </Tooltip>
              </div>
            )}
            {canDelete && (
              <div
                ml="15px"
                mr="5px"
                style={{ float: "left", marginLeft: "10px" }}
              >
                <Tooltip placement="bottom" title="Delete">
                  <Popconfirm
                    onConfirm={this.deleteAdminData.bind(this, item)}
                    title="Are you sure you want to delete Admin?"
                  >
                    <Button shape="circle" icon={<DeleteOutlined />} />
                  </Popconfirm>
                </Tooltip>
              </div>
            )}
          </div>
        );
      },
    },
  ];

  async deleteAdminData(item) {
    try {
      const {
        authToken,
        history,
        setLoginFlag,
        setUserData,
        setUserToken,
        searchText,
      } = this.props;
      const { startIndex, limitNumber } = this.state;

      this.setState({
        isLoading: true,
      });
      let deleteData = await deleteAdmin(authToken, item._id);

      if (deleteData.status === 200) {
        notification["success"]({
          message: "Delete User",
          description: "Successfully deleted",
        });

        await this.listAdminData(0, 10);
      } else if (deleteData.status === 401) {
        await setLoginFlag(false);
        await setUserData(null);
        await setUserToken(null);
        history.push(`${process.env.PUBLIC_URL}/login`);
      }
    } catch (e) {
      notification["error"]({
        message: "Delete Admin",
        description: e,
      });
    } finally {
      this.setState({
        isLoading: false,
      });
    }
  }

  async onChange(item, checked) {
    console.log("checked here ", checked);
    try {
      const {
        authToken,
        history,
        setLoginFlag,
        setUserData,
        setUserToken,
        searchText,
      } = this.props;
      const { startIndex, limitNumber } = this.state;

      this.setState({
        isLoading: true,
      });
      let statusData = await changeStatus(authToken, item._id, checked);
      if (statusData.status === 200) {
        notification["success"]({
          message: "Change Admin Status",
          description: "Successfully changed status",
        });
        if (searchText != null && searchText !== "") {
          this.listSearchAdminData(startIndex, limitNumber);
          return;
        }
        this.listAdminData(startIndex, limitNumber);
      } else if (statusData.status === 401) {
        await setLoginFlag(false);
        await setUserData(null);
        await setUserToken(null);
        history.push(`${process.env.PUBLIC_URL}/login`);
      }
    } catch (err) {
      notification["error"]({
        message: "Change Category Status",
        description: err,
      });
    } finally {
      this.setState({
        isLoading: false,
      });
    }
  }

  editSubmit = async (adminObject, adminId) => {
    try {
      const {
        authToken,
        history,
        setLoginFlag,
        setUserData,
        setUserToken,
        searchText,
      } = this.props;
      const { startIndex, limitNumber } = this.state;

      this.setState({
        isLoading: true,
      });
      let statusData = await editAdmin(authToken, adminObject, adminId);
      if (statusData.status === 200) {
        notification["success"]({
          message: "Edit Admin Status",
          description: "Successfully edited",
        });

        this.handleModalclose();
        this.listAdminData(startIndex, limitNumber);
      } else if (statusData.status === 401) {
        await setLoginFlag(false);
        await setUserData(null);
        await setUserToken(null);
        history.push(`${process.env.PUBLIC_URL}/login`);
      }
    } catch (e) {
      notification["error"]({
        message: "Edit Admin",
        description: e,
      });
    } finally {
      this.setState({
        isLoading: false,
      });
    }
  };

  handleChangePassword = async (adminObject, adminId) => {
    try {
      const {
        authToken,
        history,
        setLoginFlag,
        setUserData,
        setUserToken,
        searchText,
      } = this.props;
      const { startIndex, limitNumber } = this.state;

      this.setState({
        isLoading: true,
      });
      let statusData = await changePassword(authToken, adminObject, adminId);
      if (statusData.status === 200) {
        notification["success"]({
          message: "Edit Admin Status",
          description: "Successfully edited",
        });

        this.listAdminData(startIndex, limitNumber);
      } else if (statusData.status === 401) {
        await setLoginFlag(false);
        await setUserData(null);
        await setUserToken(null);
        history.push(`${process.env.PUBLIC_URL}/login`);
      }
    } catch (e) {
      notification["error"]({
        message: "Edit Admin",
        description: e,
      });
    } finally {
      this.setState({
        isLoading: false,
      });
    }
  };

  handleUpdateRole = async (adminObject, adminId) => {
    this.editSubmit(adminObject, adminId);
  };

  handleTableChange(pagination, filters) {
    console.log("outer onchange iusers", pagination);
    this.setState(
      {
        pagination,
      },
      () => this.getLimitedAdmin(pagination)
    );
  }

  render() {
    const { isLoading, data } = this.state;
    const { listAdminData, listAdminDataTotal, searchLoader } = this.props;

    return isLoading || searchLoader ? (
      <div style={{ marginLeft: "20px", alignItems: "center" }}>
        <Spin
          size="large"
          style={{ marginLeft: "480px", marginTop: "130px" }}
        />
      </div>
    ) : (
      <div style={{ overflowX: "auto" }}>
        <Table
          loading={this.state.isLoading}
          rowKey={(record) => record._id}
          columns={this.columns}
          size={"small"}
          // dataSource={this.state.data}
          dataSource={listAdminData}
          pagination={{
            total: listAdminDataTotal,
            showSizeChanger: true,
            pageSize: this.state.pagination.pageSize,
            current: this.state.pagination.current,
            pageSizeOptions: ["1", "10", "25", "50", "100"],
            selectComponentClass: NativeSelect,
            onChange: (e) => {
              console.log("onChanges pagination");
              // e - 1
              //   ? (this.counter = this.tempCounter =
              //       (e - 1) * this.state.pagination.pageSize)
              //   : ((this.counter = 0), (this.tempCounter = 0));
              if (e - 1) {
                this.counter = this.tempCounter =
                  (e - 1) * this.state.pagination.pageSize;
                return;
              }

              this.counter = 0;
              this.tempCounter = 0;
            },
          }}
          onChange={this.handleTableChange}
        />

        {this.state.adminSelectedData ? (
          <EditModal
            admin={false}
            refx={(e) => (this.modalRef = e)}
            onClose={this.handleModalclose.bind(this)}
            adminSelectedData={this.state.adminSelectedData}
            onSubmit={this.editSubmit}
          />
        ) : null}

        <ChangePassowordModal
          admin={false}
          refx={(e) => (this.changePasswordmodalRef = e)}
          onClose={this.handleModalclose.bind(this)}
          adminSelectedData={this.state.adminSelectedData}
          onChangePassword={this.handleChangePassword}
        />

        <UpdateRoleModal
          admin={false}
          refx={(e) => (this.changeUpdateRoleModalRef = e)}
          onClose={this.handleModalclose.bind(this)}
          adminSelectedData={this.state.adminSelectedData}
          onSubmit={this.handleUpdateRole}
        />
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  authToken: state.auth.authToken,
  listAdminData: state.admin.listAdminData,
  listAdminDataTotal: state.admin.listAdminDataTotal,
  searchLoader: state.auth.searchLoader,
  searchText: state.auth.searchText,
  userData: state.auth.userData,
  loginUserData: state.auth.loginUserData,
  admin: state.admin, 
});

const mapDispatchToProps = (dispatch) => {
  return {
    setLoginFlag: (flag) => {
      dispatch({
        type: "SET_LOGIN_FLAG",
        flag: flag,
      });
    },
    setUserData: (userData) => {
      dispatch({
        type: "SET_USER_DATA",
        userData: userData,
      });
    },
    setUserToken: (authToken) => {
      dispatch({
        type: "SET_USER_AUTHTOKEN",
        authToken: authToken,
      });
    },
    setListAdminData: (listAdminData) => {
      dispatch({
        type: "SET_LIST_ADMIN_DATA",
        listAdminData: listAdminData,
      });
    },
    setListAdminDataTotal: (listAdminDataTotal) => {
      dispatch({
        type: "SET_LIST_ADMIN_DATA_TOTAL",
        listAdminDataTotal: listAdminDataTotal,
      });
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(AdminRecordsTable));
